module.exports = __webpack_public_path__ + "img/icon-contractor-work-volume.1c14f459.png";